import { api } from '@/lib/axios';
import type {
  ClientsListResponse,
  ClientDetail,
  ClientFilter,
} from '@/types/admin';

export const clientsService = {
  /**
   * Fetch clients list with filtering, searching, and pagination
   */
  async fetchClients(params: {
    filter?: ClientFilter;
    search?: string;
    page?: number;
    per_page?: number;
  }): Promise<ClientsListResponse> {
    const { data } = await api.get<ClientsListResponse>('/v1/admin/clients', {
      params,
    });
    return data;
  },

  /**
   * Fetch detailed information for a specific client
   */
  async fetchClientDetail(userId: string): Promise<ClientDetail> {
    const { data} = await api.get<ClientDetail>(`/v1/admin/clients/${userId}`);
    return data;
  },
};
